export interface Testimonial {
  id: string;
  userName: string;
  userAvatar: string;
  role: string;
  content: string;
  rating: number;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't001',
    userName: '小明的快乐生活',
    userAvatar: 'https://readdy.ai/api/search-image?query=Happy%20smiling%20cartoon%20boy%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20yellow%20and%20white%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=testimonial-avatar-001&orientation=squarish',
    role: '搞笑类创作者 | 粉丝120万',
    content: '自从加入香蕉视频，我的创作之路完全改变了！平台的推荐算法太强了，我的第三个视频就火遍了全网，现在每个月的收入比我上班还多。最重要的是这里的社区氛围特别好，粉丝互动很积极。',
    rating: 5,
    date: '2026-07-15',
  },
  {
    id: 't002',
    userName: '美食探险家Lucy',
    userAvatar: 'https://readdy.ai/api/search-image?query=Cheerful%20cartoon%20girl%20with%20chef%20hat%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20orange%20and%20cream%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=testimonial-avatar-002&orientation=squarish',
    role: '美食类创作者 | 粉丝85万',
    content: '作为一个美食博主，香蕉视频的视频画质和对竖屏的支持真的让我惊喜。上传超方便，剪辑工具也很好用。半年前还是个厨房小白，现在已经有85万粉丝了，太不可思议了！',
    rating: 5,
    date: '2026-06-28',
  },
  {
    id: 't003',
    userName: '数码控阿杰',
    userAvatar: 'https://readdy.ai/api/search-image?query=Cool%20cartoon%20boy%20with%20glasses%20avatar%20icon%2C%20simple%20flat%20design%2C%20teal%20and%20gray%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=testimonial-avatar-003&orientation=squarish',
    role: '科技类创作者 | 粉丝200万',
    content: '专业的创作者后台数据面板太赞了！能清晰看到每个视频的播放趋势、观众画像和互动数据，帮助我不断优化内容方向。香蕉视频的「香蕉星计划」也给了我很多流量扶持和商业合作机会。',
    rating: 5,
    date: '2026-07-03',
  },
  {
    id: 't004',
    userName: '旅行摄影师小康',
    userAvatar: 'https://readdy.ai/api/search-image?query=Adventurous%20cartoon%20photographer%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20green%20and%20cream%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=testimonial-avatar-004&orientation=squarish',
    role: '旅行类创作者 | 粉丝65万',
    content: '走遍世界各地拍摄的视频终于在香蕉视频找到了最好的展示平台。高清画质完美呈现了我拍摄的每一个细节，评论区来自世界各地的观众互动让我感到特别温暖。',
    rating: 4,
    date: '2026-06-15',
  },
  {
    id: 't005',
    userName: '音乐人小雨',
    userAvatar: 'https://readdy.ai/api/search-image?query=Musical%20cartoon%20girl%20with%20headphones%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20pink%20and%20white%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=testimonial-avatar-005&orientation=squarish',
    role: '音乐类创作者 | 粉丝150万',
    content: '在香蕉视频发布原创音乐的体验太棒了！音质无损上传、歌词自动同步这些功能对我们音乐人来说太实用了。平台还帮我对接了音乐平台的发行合作，现在我的歌已经在各大音乐平台上线了！',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 't006',
    userName: '体育迷小王',
    userAvatar: 'https://readdy.ai/api/search-image?query=Sporty%20cartoon%20boy%20with%20basketball%20avatar%20icon%2C%20simple%20flat%20design%2C%20red%20and%20white%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=testimonial-avatar-006&orientation=squarish',
    role: '普通用户 | 活跃用户2年',
    content: '作为一个普通观众，香蕉视频已经成为我每天必刷的APP。推荐的内容越来越精准，刷到的都是我爱看的体育和游戏类视频。评论区氛围也比较好，不像其他平台那么多喷子。',
    rating: 5,
    date: '2026-07-10',
  },
];